export const AUTHORIZATION_SUCCESS = 'AUTHORIZATION_SUCCESS';
export const LOGGED_DATA_UPDATE = 'LOGGED_DATA_UPDATE';
export const MESSAGES_UPDATE = 'MESSAGES_UPDATE';
export const ATTACHMENTS_UPDATE = 'ATTACHMENTS_UPDATE';
export const IS_JANUS_CALL = 'IS_JANUS_CALL';
export const IS_NODE_DISCONNECTED = 'IS_NODE_DISCONNECTED';
export const REVIEW_ISSUES = 'REVIEW_ISSUES';
export const CALL_ID = 'CALL_ID';
export const UPDATE_UNREAD_MESSAGE = 'UPDATE_UNREAD_MESSAGE';
export const JITSI_JOINED = 'JITSI_JOINED';
export const CHAT_MESSAGES_UPDATE = 'CHAT_MESSAGES_UPDATE';
export const UPDATE_UNREAD_PRIVATE_CHATS = 'UPDATE_UNREAD_PRIVATE_CHATS';
export const SET_SELECTED_CHAT = 'SET_SELECTED_CHAT';
export const UPDATE_UNREAD_GROUP_CHAT = 'UPDATE_UNREAD_GROUP_CHAT';
